// ÁTTEKINTÉS — query-kulcsok egy helyen. A preferencia-kulcsok (`['preferences', …]`) a mentett elrendezés / jegyzet
// cache-azonosítói; az optimista írás és az invalidálás ugyanezt a kulcsot használja.
export const dashboardKeys = {
  layout: ['preferences', 'dashboard'] as const,
  notes: ['preferences', 'notes'] as const,
  celebrations: (days: number) => ['dashboard', 'celebrations', days] as const,
  myTickets: ['dashboard', 'my-tickets'] as const,
};

/** A cache-ben tárolt ts-rest válasz laza alakja (az optimista íráshoz: a státusz + a nyers body). */
export interface CachedResponse {
  status: number;
  body: unknown;
  headers: Headers;
}

/** A preferencia-dokumentum burkolója (`{ value, version, updatedAt }`) — a cache-írás őre. */
export interface PreferenceEnvelopeLike {
  value: unknown;
  version: number;
  updatedAt: string | null;
}

export function isEnvelope(body: unknown): body is PreferenceEnvelopeLike {
  return (
    typeof body === 'object' &&
    body !== null &&
    'version' in body &&
    typeof body.version === 'number'
  );
}

/** Az optimista cache-írás: ugyanaz a válasz, csak a `value` más — a `version` marad (a valódit a siker írja be). */
export function withEnvelopeValue(
  old: CachedResponse | undefined,
  value: unknown,
): CachedResponse | undefined {
  if (old?.status !== 200 || !isEnvelope(old.body)) return old;
  return { ...old, body: { ...old.body, value } };
}
